import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '@app/core/services/auth.service';

export const adminGuard: CanActivateFn = (_: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const url: string = state.url;
  if (authService.user.isEngie) return true;
  // Store the attempted URL for redirecting
  if (url !== '/errors/404') authService.redirectUrl = url;
  // Navigate to the login page
  return router.navigate(['/']);
};
